import qc from 'qc'
import { scripts } from '@ps/bridge/qc/scripts/index'
import gameIframe from '@ps/bridge/iframe/iframe'

export interface VideoScript {
  sourceVideoUrl: string; // 原视频 URL
  sourceVideoDuration: number; // 原视频时长
  videoUrl: string; // 当前视频 URL
  audioUrl: string; // 当前音频 URL
  playEndFrame: number; // 播放结束显示画面 0: 第一帧，1: 最后一帧
  loopNumber: number; // [<= 0]:循环 [>0]:次数播放
  clipStartTime: number; // 上一次裁剪起始时间，单位毫秒
  clipEndTime: number; // 上一次裁剪结束时间，单位毫秒
  assetId: number; // 资源库 id
  autoPlay: boolean; // 是否自动播放
  isMute: boolean; // 是否静音
  onRefresh: () => void;
  onDisable: () => void;
  stop: () => void;
  pause: () => void;
  play: (isReplay: boolean) => void; // isReplay: 是否重播
  videoLoaded: boolean; // 是否 load 完
  eventDisp: qc.Signal;
  _isStop: boolean; // 播放暂停状态
  _playTimes: number; // 循环播放次数
  player: HTMLVideoElement; // 播放器状态下 player 肯定是 video 标签
  $data: { // $data 是动态配置，如果仅仅是要新增属性的话，添加到 $data 中，就不需要修改脚本
    nativeSize: {
      width: number;
      height: number;
    }
  }
}

/**
 * ps.Video 脚本在编辑与线上运行的时候都会加载进去
 * @param node
 * @param addScriptIfScriptNotExist
 */
export const getScript = (node: qc.Node, addScriptIfScriptNotExist = true): VideoScript | undefined => {
  const config: VideoScript | undefined = node.getScript(scripts.video.name)
  if (config) {
    return config
  }
  if (addScriptIfScriptNotExist) {
    return node.addScript(scripts.video.name) as VideoScript
  }
  return config
}

/**
 * 判断当前视频脚本是否支持 mp4 播放
 * @returns {boolean}
 */
export const checkIsSupportMP4 = (): boolean => {
  const supportAbility = (gameIframe.ps.Video.__ability || '').split(',')
  return supportAbility.indexOf('mp4') !== -1
}
